const media = {
  contentTypeId: 'dynamic-elements-media-preview',
  inputs: {
    media: {
      provider: 'id:root',
      property: 'mediaUrl',
      transform: function (url: string) {
        return {
          url,
        };
      }.toString(),
    },
  },
  styles: {
    classes: ['col-xl-6', 'col-8'],
  },
};

const text = {
  contentTypeId: 'dynamic-elements-simple-text',
  inputs: {
    text: {
      provider: 'id:root',
      property: 'description',
    },
  },
  styles: {
    classes: ['d-block', 'my-2', 'h2'],
  },
};

const button = {
  contentTypeId: 'dynamic-elements-link',
  styles: {
    classes: ['btn', 'btn-block', 'btn-primary', 'btn-xxl'],
  },
  inputs: {
    hrefUrl: {
      provider: 'id:root',
      property: 'buttonUrl',
    },
    target: '_blank',
  },
  children: [
    {
      contentTypeId: 'dynamic-elements-simple-text',
      inputs: {
        text: {
          provider: 'id:root',
          property: 'buttonText',
        },
      },
    },
  ],
};

export const bannerWithButton = {
  id: 'root',
  contentTypeId: 'dynamic-collections-renderer',
  data: {
    mediaUrl:
      'https://epicuropumatestimages.epicurotesting.com/images/static/logos/logo-dark.png?mode=max&scale=both',
    description: '@@basketSurveyDescription',
    buttonText: '@@basketSurveyButtonText',
    buttonUrl: 'https://forms.office.com/r/cPk3rYBg1k',
    globalCss: '',
    rootDynamicClasses: '',
    panelStyle: 'display: block;margin-top:40px;',
  },
  children: [media, text, button],
  styles: {
    classes: ['d-flex', 'align-items-center', 'flex-column'],
    css: {
      provider: 'self',
      property: 'globalCss',
      filter: function (css: string | null | undefined): boolean {
        return css !== undefined && css !== null && css.trim() !== '';
      }.toString(),
    },
    dynamicClasses: { provider: 'self', property: 'rootDynamicClasses' },
    style: {
      __multiple__: {
        provider: 'id:root',
        property: 'panelStyle',
      },
    },
  },
};
